var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appointments"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('Menu',{attrs:{"title":"Appointments"}}),_c('div',{staticClass:"col-12 p-0"},[_c('Appointment',{style:({
                    width : !_vm.$store.state.menu_toggle ? 'calc(100% - 70px)' : 'calc(100% - 255px )',
                }),attrs:{"id":"appoint_view"}})],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }